var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{ref:"canvas",staticClass:"v-fade-out-in"})
}
var staticRenderFns = []

export { render, staticRenderFns }